import { RadioGroup as MuiRadioGroup, RadioGroupProps as MuiRadioGroupProps } from '@mui/material';
import React from 'react';

export interface RadioGroupProps extends MuiRadioGroupProps {}

export const RadioGroup = (props: RadioGroupProps) => <MuiRadioGroup {...props} />;
